import React, { createContext, useContext } from 'react';
import { GA_TRACKING_ID } from 'src/lib/gtag';
import * as PortalApi from '../lib/portal-api';

export interface StatusStoreContext {
  accessToken: string;
  status: PortalApi.StatusViewModel;
}

const defaultState = {
  accessToken: '',
  status: {},
};

export const StatusContext = createContext<StatusStoreContext>(defaultState);
export const useStatus = (): StatusStoreContext => useContext(StatusContext);

interface StatusContextProviderProps {
  accessToken?: string;
}

export class StatusContextProvider extends React.Component<
  StatusContextProviderProps,
  StatusStoreContext
> {
  state = defaultState;

  async updateSystemStatus(accessToken?: string): Promise<void> {
    const getStatus = (token: string, gaClientId = '') => {
      PortalApi.getStatus(token, gaClientId).then((systemStatus) => {
        this.setState({
          // eslint-disable-next-line react/no-unused-state
          status: systemStatus,
          // eslint-disable-next-line react/no-unused-state
          accessToken: token,
        });
      });
    };

    let clientId = '';

    if (accessToken) {
      window.gtag('get', GA_TRACKING_ID, 'client_id', (gaClientId: string) => {
        clientId = gaClientId;
        getStatus(accessToken, gaClientId);
      });

      // If not able to get the GA client id, e.g. if an ad blocker is enabled,
      // then ensure that PortalApi.getStatus still runs.
      // The gtag function above doesn't throw exceptions unfortunately, so need this hack
      setTimeout(async () => {
        if (!clientId) {
          getStatus(accessToken);
        }
      }, 1000);
    } else {
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        status: {},
        // eslint-disable-next-line react/no-unused-state
        accessToken: '',
      });
    }
  }

  async componentDidUpdate(
    prevProps: StatusContextProviderProps,
  ): Promise<void> {
    if (prevProps.accessToken !== this.props.accessToken) {
      await this.updateSystemStatus(this.props.accessToken);
    }
  }

  render(): React.ReactNode {
    return (
      <StatusContext.Provider value={this.state}>
        {this.props.children}
      </StatusContext.Provider>
    );
  }
}
